import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

class CustomInput extends PureComponent {
  onChange = (event) => {
    const {
      currentTarget: { value: newVal, checked },
    } = event;
    const { id, onChange, type } = this.props;
    let value = type === 'checkbox' ? checked : newVal;

    if (value === '') {
      value = undefined;
    }

    onChange(id, value);
  };

  renderInput = () => {
    const {
      controlType, type, placeholder, id, disabled, value, errors,
    } = this.props;


    switch (controlType) {
      default:
        return null;
      case 'textarea':
        return (
          <textarea
            className="form-control"
            rows="5"
            id={id}
            value={value}
            onChange={this.onChange}
          />
        );
      case 'input':
        switch (type) {
          case 'checkbox':
            return (
              <input
                className="form-control h-75"
                id={id}
                placeholder={placeholder}
                onChange={this.onChange}
                type={type}
                checked={value}
                disabled={disabled}
              />
            );
          default:
            return (
              <input
                className={`form-control ${errors && get(errors, id) ? 'border border-danger' : ''}`}
                id={id}
                placeholder={placeholder}
                onChange={this.onChange}
                type={type}
                value={value}
                disabled={disabled}
              />
            );
        }
    }
  };

  render() {
    const {
      label,
      id,
      horizontal,
      errors,
    } = this.props;

    if (horizontal) {
      return (
        <div className="row form-group">
          <div className="col col-md-3">
            <label htmlFor={id} className="form-control-label">
              {label}
            </label>
          </div>
          <div className="col-12 col-md-9">
            {this.renderInput()}
            {errors && get(errors, id) && <div className="errors text-danger">{get(errors, id)}</div>}
          </div>
        </div>
      );
    }

    return (
      <div className="form-group">
        <label>{label}</label>
        {this.renderInput()}
      </div>
    );
  }
}

CustomInput.defaultProps = {
  label: '',
  controlType: 'input',
  type: 'text',
  placeholder: '',
  horizontal: false,
  disabled: false,
  value: '',
};

CustomInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  horizontal: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  controlType: PropTypes.string,
};

export default CustomInput;
